const MS_DAY = 24 * 60 * 60 * 1000

function tryParseDate(input) {
	if (input == null || input === '') return null
	if (input instanceof Date && !Number.isNaN(input.getTime())) return input
	const s = String(input).trim()
	if (!s) return null
	const iso = Date.parse(s)
	if (!Number.isNaN(iso)) return new Date(iso)
	const m = s.match(
		/(\d{1,2})[./-](\d{1,2})[./-](\d{2,4})/,
	)
	if (m) {
		const d = Number(m[1])
		const mo = Number(m[2]) - 1
		let y = Number(m[3])
		if (y < 100) y += 2000
		const dt = new Date(y, mo, d)
		return Number.isNaN(dt.getTime()) ? null : dt
	}
	return null
}

function formatDue(d) {
	return d.toLocaleDateString(undefined, {
		day: 'numeric',
		month: 'short',
		year: '2-digit',
	})
}

/**
 * @param {string|Date|null|undefined} deadlineRaw — e.g. from university profile / application
 * @returns {{ variant: 'overdue'|'soon'|'ok'|'neutral', text: string }}
 */
export function getNudgeDeadlineBanner(deadlineRaw) {
	const d = tryParseDate(deadlineRaw)
	const now = new Date()
	const suffix = ' No upload yet.'

	if (!d) {
		return {
			variant: 'neutral',
			text: `Please upload the requested document.${suffix}`,
		}
	}

	const startOf = x => {
		const t = new Date(x)
		t.setHours(0, 0, 0, 0)
		return t
	}
	const days = Math.round((startOf(d) - startOf(now)) / MS_DAY)
	const dueStr = formatDue(d)

	if (days < 0) {
		return {
			variant: 'overdue',
			text: `Deadline passed (${dueStr}).${suffix}`,
		}
	}
	if (days === 0) {
		return {
			variant: 'soon',
			text: `Due today (${dueStr}).${suffix}`,
		}
	}
	if (days === 1) {
		return {
			variant: 'soon',
			text: `1 day left, due on ${dueStr}.${suffix}`,
		}
	}
	if (days <= 3) {
		return {
			variant: 'soon',
			text: `${days} days left, due on ${dueStr}.${suffix}`,
		}
	}
	return {
		variant: 'ok',
		text: `Due on ${dueStr}.${suffix}`,
	}
}
